import { createTheme } from '@mui/material/styles';

// Base colors shared across themes
const baseColors = {
  textColor: '#222222',
  backgroundColor: '#fff',
  fontFamily: 'Mulish, sans-serif',
  iconColor: '#888888',
  // Profile specific colors
  profileText: '#222222',
  profileCardBg: '#ffffff',
  profileBorder: '#f3f3f3',
  profileMuted: '#888888',
  profileSubtle: '#bbbbbb',
  profileSuccess: '#4caf50',
  // KYC specific colors
  kycVerifiedColor: '#43a047',
  kycPendingColor: '#1976d2',
  kycFailedColor: '#d32f2f',
  // Status theme colors
  deliveredBg: '#e8fbe6',
  deliveredColor: '#27ae60',
  inTransitBg: '#fffbe6',
  inTransitColor: '#f7b500',
  cancelledBg: '#fff0f0',
  cancelledColor: '#e74c3c',
  pendingColor: '#1976d2',
  pendingBg: '#bbdefb',
  assignedColor: '#ff9800',
  assignedBg: '#fff3e0',
  completedColor: '#388e3c',
  completedBg: '#e8f5e9',
  returnedColor: '#6d4c41',
  returnedBg: '#efebe9',
  failedColor: '#c62828',
  failedBg: '#ffebee',
};

// Individual user theme - BLACK focused, minimal and professional with accent colors
const individualTheme = {
  ...baseColors,
  primaryColor: '#000000',
  accentBlue: '#3B82F6',
  accentPurple: '#8B5CF6',
  accentGreen: '#10B981',
  accentOrange: '#F59E0B',
  accentCyan: '#06B6D4',
  headersColor: '#1a1a1a',
  contrastText: '#ffffff',
  accentColor: '#000000',
  gradientPrimary: 'linear-gradient(135deg, #000000 0%, #2d2d2d 100%)',
  gradientBg: 'linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)',
  gradientBgFallback: '#f5f5f5',
  heroGradient: 'linear-gradient(135deg, #000000 0%, #333333 100%)',
  textShadow: 'none',
};

// Business user theme - Dark/professional, black focused
const businessTheme = {
  ...baseColors,
  primaryColor: '#1a1a1a',
  headersColor: '#0f0f0f',
  contrastText: '#ffffff',
  accentColor: '#f59e0b', // Amber accent for business
  gradientPrimary: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
  gradientBg: 'linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)',
  gradientBgFallback: '#f5f5f5',
  heroGradient: 'linear-gradient(135deg, #1a1a1a 0%, #333333 100%)',
  textShadow: 'none',
};

// Default theme colors (individual by default)
const themeColors = {
  ...individualTheme,
};

// Helper function to get theme by user type
const getThemeByUserType = (userType) => {
  return userType === 'business' ? businessTheme : individualTheme;
};

const theme = createTheme({
  palette: {
    primary: {
      main: themeColors.primaryColor,
    },
    background: {
      default: themeColors.backgroundColor,
    },
    text: {
      primary: themeColors.textColor,
    },
    headers: {
      main: themeColors.headersColor,
    },
    secondary: {
      main: '#FF7301',
    },
  },
  typography: {
    fontFamily: themeColors.fontFamily,
    h1: { color: themeColors.headersColor },
    h2: { color: themeColors.headersColor },
    h3: { color: themeColors.headersColor },
  },
  customColors: themeColors, // for easy access in JS
});

export default theme;
export { themeColors, getThemeByUserType, individualTheme, businessTheme };
